import React, { useState } from 'react';
import { predictionData, predictionCategories, trendingPredictions } from '../data/predictionData';
import { PredictionsList } from '../components/prediction/PredictionsList';
import { PredictionCategories } from '../components/prediction/PredictionCategories';
import { FeaturedPrediction } from '../components/prediction/FeaturedPrediction';
import { PredictionSidebar } from '../components/prediction/PredictionSidebar';
export const PredictionPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  // Get featured prediction (first one for simplicity)
  const featuredPrediction = predictionData[0];
  const handleCategoryChange = (categoryId: string) => {
    setActiveCategory(categoryId);
  };
  return <main className="flex-grow container mx-auto px-4 py-6 lg:px-6" data-id="element-442">
      <div className="mb-8" data-id="element-443">
        <h1 className="text-3xl font-bold mb-2" data-id="element-444">Prediction Markets</h1>
        <p className="text-gray-600" data-id="element-445">
          Predict the outcome of future events and win rewards if you're right.
        </p>
      </div>
      <PredictionCategories categories={predictionCategories} activeCategory={activeCategory} onSelectCategory={handleCategoryChange} data-id="element-446" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-447">
        <div className="lg:col-span-8" data-id="element-448">
          <FeaturedPrediction prediction={featuredPrediction} data-id="element-449" />
          <h2 className="text-xl font-bold mb-6" data-id="element-450">
            {activeCategory === 'all' ? 'All Prediction Markets' : `${predictionCategories.find(c => c.id === activeCategory)?.name}`}
          </h2>
          <PredictionsList predictions={predictionData} category={activeCategory} featuredId={featuredPrediction.id} data-id="element-451" />
        </div>
        <div className="lg:col-span-4" data-id="element-452">
          <PredictionSidebar trendingPredictions={trendingPredictions} data-id="element-453" />
        </div>
      </div>
    </main>;
};